import orgHttps from '../init/orgHttps';

//ORG-GUID-01 : Populate the information on guid dashboard
export async function orgGudashFun() {
    const result = await orgHttps.get(`/org/gu`);
    return result;
}

//ORG-GUID-02 : To get complete content of guid tour
export async function orgGuidTourFun(guidTourId) {
    const result = await orgHttps.get(`/org/gu/tours/${guidTourId}`);
    return result;
}

//ORG-GUID-03 : Gives the list of booked customers for given guid tour
export async function orgGuBookedOnDate(guidTourId, date) {
    const result = await orgHttps.get(`/org/gu/booked/${guidTourId}/${date}`);
    return result;
}

//ORG-GUID-04 : Search in organizer page
export async function orgGuidSearchFun(text) {
    const result = await orgHttps.get(`/org/guid/search?name=${text}`);
    return result;
}

//ORG-GUID-05 : Complete details of an organizer
export async function guidOrgInfoFun() {
    const result = await orgHttps.get(`/org/guid/orgInfo`);
    return result;
}

//ORG-GUID-06 : Create new guid organizer
export async function orgGuidRegisterFun(data) {
    const result = await orgHttps.post(`org/gu/register`, data);
    return result;
}

//ORG-GUID-07 : To add new guid tour details
export async function guidTourCreateFun(data) {
    const result = await orgHttps.post(`/org/gu/create`, data);
    return result;
}

//ORG-GUID-08 : To add new booking manually
export async function guidDateMnFun(data) {
    const result = await orgHttps.post(`org/gu/manual`, data);
    return result;
}

//ORG-GUID-09 : To delete guid tour
//dont let the guid to be deleted even if it has single booking //it has to be cancalled
export async function guidTourDeleteFun(guidTourId) {
    const result = await orgHttps.delete(`org/guid/${guidTourId}`);
    return result;
}

// ORG-GUID-10 list of guide packages of particular organizer
export async function guideOrgPackListFun(status, limit, offset) {
    const result = await orgHttps.get(`/org/gu/packs?status=${status}&limit=${limit}&offset=${offset}`);
    return result;
}

//ORG-GUID-11 : get OTP to register guide organizer
export async function orgGuRegOTP(data, method) {
    const result = await orgHttps.post(`org/gu/register/otp?method=${method}`, data);
    return result;
}

// ORG-GUID-12 List of booking for particular organizer
export async function orgGuBookingList(date, limit, offset, tourid) {
    const result = await orgHttps.get(
        `/org/gu/booked/list?date=${date}&limit=${limit}&offset=${offset}&tourid=${tourid}`
    );
    return result;
}
// ORG-GUID-13 Dropdowns for guide list in page bookings and Reviews
export async function orgGuidListData() {
    const result = await orgHttps.get(`/org/gu/packs/list/dropdown`);
    return result;
}

// ORG-GUID-14 to block or delete unavailable dates to a guide tour
export async function orgGuideUnavailableDateFun(data, option) {
    const result = await orgHttps.patch(`/org/gu/unavai/date?option=${option}`, data);
    return result;
}

// ORG-GUID-15 List of billing for the guide organizer
export async function orgGuidBillingData(status, approval, limit, offset) {
    const result = await orgHttps.get(
        `/org/gu/billing?status=${status}&approval=${approval}&limit=${limit}&offset=${offset}`
    );
    return result;
}

// ORG-GUID-16 - Edit guide when its active, limited things can be edited
export async function orgActiveGuidEditFun(guideId, data) {
    const result = await orgHttps.patch(`/org/gu/active/${guideId}`, data);
    return result;
}

// ORG-GUID-17 Edit guide when its inactive, whole guide can be edited
export async function orgInactiveGuidEditFun(guideId, data) {
    const result = await orgHttps.put(`/org/gu/inactive/${guideId}`, data);
    return result;
}

// ORG-GUID-18 list of payouts for guide organizer
export async function orgGuidPayouts(limit, offset) {
    const result = await orgHttps.get(`/org/gu/payouts?limit=${limit}&offset=${offset}`);
    return result;
}

// ORG-GUID-19 count tours of particular organizer
export async function orgGuidPackagesCount(status) {
    const result = await orgHttps.get(`/org/gu/count/tours?status=${status}`);
    return result;
}

// ORG-GUID-20 Count of booking for particular organizer
export async function orgGuidBookingCount(date, tourid) {
    const result = await orgHttps.get(`/org/gu/count/booked?date=${date}&tourid=${tourid}`);
    return result;
}

// ORG-GUID-21 Count of billing for the guide organizer
export async function orgGuidBillingCount(status, approval) {
    const result = await orgHttps.get(`/org/gu/count/billing?status=${status}&approval=${approval}`);
    return result;
}

// ORG-GUID-22 Count of payouts for guide organizer
export async function orgGuidPayoutsCount() {
    const result = await orgHttps.get(`/org/gu/count/payouts`);
    return result;
}

// ORG-GUID-23 Details of a particular guide payout
export async function orgGuPayoutsMoreData(id) {
    const result = await orgHttps.get(`org/gu/payout/details/${id}`);
    return result;
}

// ORG-GUID-24 Get dates for a guide tour
export async function orgGuideDates(guid, dateType, offset, limit) {
    const result = await orgHttps.get(`/org/gu/date/${guid}`, {
        params: {
            date: dateType,
            offset,
            limit
        }
    });
    return result;
}

// ORG-GUID-25 Guide organizer dashboard data
export async function orgGuDashboardData(date = 'next', bookingsOnly = true, offset = 0, limit = 10) {
    return await orgHttps.get(
        `/org/gu/dashboard?date=${date}&bookingsOnly=${bookingsOnly}&offset=${offset}&limit=${limit}`
    );
}

// ORG-GUID-26 List of bookings for a particular guide slot
export async function orgGuSlotBookings(actDatesId, slotId, offset = 0, limit = 10) {
    return await orgHttps.get(`/org/gu/dashboard/${actDatesId}/${slotId}/bookings?offset=${offset}&limit=${limit}`);
}

// ORG-GUID-27 Cancel a single guide booking
export async function orgBookingCancelFun(data) {
    const result = await orgHttps.patch(`org/gu/cancel/each/booking`, data);
    return result;
}

// ORG-GUID-28 Add a new time slot to a guide tour date
export async function orgAddTimeSlot(id, type, data) {
    return await orgHttps.post(`/org/gu/date/${id}`, data);
}

// ORG-GUID-29 Edit a guide tour slot
export async function orgUpdateGuideSlot(dateId, slotId, data) {
    return await orgHttps.patch(`/org/gu/date/${dateId}/slot/${slotId}`, data);
}

// ORG-GUID-30 Delete a guide tour slot
export async function orgDeleteGuideSlot(dateId, type, slotId) {
    return await orgHttps.delete(`/org/gu/date/${dateId}/slot/${slotId}`);
}

// ORG-GUID-31 Delete a guide tour date
export async function orgDeleteGuideDate(dateId, type) {
    return await orgHttps.delete(`/org/gu/delete/date/${dateId}`);
}
